import { call, put, select, takeLatest } from "redux-saga/effects";
import { accessTokenSelector } from "../../auth/selectors/token";
import MetricsService from "../services/Metrics.service";
import {
  FETCH_DASHBOARDS_REQUEST,
  fetchDashboardsSuccess,
  fetchDashboardsFailure,
} from "../actions/dashboards";

export function* fetchDashboardsSaga() {
  try {
    const service = new MetricsService();
    const token = yield select(accessTokenSelector);
    const data = yield call([service, service.getDashboards], { token });
    yield put(fetchDashboardsSuccess(data));
  } catch (error) {
    yield put(fetchDashboardsFailure(error));
  }
}

export default function* watchDashboards() {
  yield takeLatest(FETCH_DASHBOARDS_REQUEST, fetchDashboardsSaga);
}
